import React from "react";
import Card from "react-bootstrap/Card";
import { ImArrowRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi, I am Hemang Sharma. Ever since I was a kid, developing software has been my passion. I still remember when I got my first iPod, it changed everything for me. It showed me a new world, it was almost magical.<br/>
            Throughout middle and high school, I latched on to any ideas for projects I could get, moving from "Hello World" all the way to a simple games made with engines. I learned HTML, then CSS, tearing through any books I could find on anything remotely related to web-development. I was insatiable.<br/>
            So, now, in industry, this passion remains with me. There's certainly yet more to learn, yet more problems to solve, and yet more to build.
            <br></br>
            <br></br>
            My professional experience includes :
            <ul>
              <li className="about-activity">
                <ImArrowRight/> <span className="purple">iOS Developer</span> at WeHear (July - September 2020) 
              </li>
              <li className="about-activity">
                <ImArrowRight/>  <span className="purple">Brand Representative</span> at Verzeo (January - February 2020)
              </li>
              <li className="about-activity">
                <ImArrowRight/>  <span className="purple">Project Operations Department Volunteer</span> at Bal Bharti (July - September 2020)
              </li>
              <li className="about-activity">
                <ImArrowRight/>  <span className="purple">Campaign Volunteer</span> at DoSomething.Org (June 2020)
              </li>
            </ul>
          <br/>
          <br/>
          My Publications includes :
          <ul>
            <li>
              <a rel="noopener noreferrer canonical" href="https://www.irjet.net/archives/V9/i9/IRJET-V9I923.pdf" target="_blank">Augmented Reality: An Emerging Paradigm</a>
            </li>
            <li>
              <a rel="noopener noreferrer canonical" href="https://www.irjet.net/archives/V7/i5/IRJET-V7I533.pdf" target="_blank">Cyborgs: Machine in Disguise?</a>
            </li>
            <li>
              <a rel="noopener noreferrer canonical" href="https://www.linkedin.com/pulse/patience-perseverance-always-bears-hemang-sharma/" target="_blank">Patience And Perseverance Always Bears</a>
            </li>
          </ul>
            <br/>
            <br/>
             <strong>Apart from coding, some other activities that I love to do!</strong>
          </p>
          <ul>
            <li className="about-activity2">
              <ImArrowRight /> <a rel="noopener noreferrer canonical" href="https://music.apple.com/profile/TribunalWolf"> Listen to Music</a>
            </li>
            <li className="about-activity2">
              <ImArrowRight /><a rel="noopener noreferrer canonical"  href="https://account.xbox.com/en-US/Profile?gamerTag=TribunalWolf678"> Play Video Games</a>
            </li>
            <li className="about-activity2">
              <ImArrowRight /><a rel="noopener noreferrer canonical" href="https://www.tiktok.com/@hemang_hs?lang=en"> Travelling</a> 
            </li>
            <li className="about-activity2">
              <ImArrowRight /> <a rel="noopener noreferrer canonical" href="https://www.instagram.com/hemang_hs/"> Photography </a>
            </li>
          </ul>
          <br></br>
          <p style={{ color: "#0b73e3" }}>
            " Chasing Dreams "{" "}
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
